import styled, { css } from 'styled-components';
import { devices } from '../../../juristec-ui/core/breakpoints';
import { gap } from '../../../juristec-ui/styles/theme';

export const GroupsTableContainer = styled.div`
  padding: 0 5%;
  @media ${devices.tablet} {
    padding: 0 20px;
  }
`;

export const GroupsTableOverFlow = styled.div`
  overflow-y: auto;
  overflow-x: auto;
  padding-bottom: 65px;
  box-sizing: border-box;
  height: calc(100vh - 137px);

  @media ${devices.tablet} {
    height: calc(100vh - 125px);
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  ${gap('8px', 'row')}
`;

export const Options = styled.div`
  display: flex;
  justify-content: center;
  ${gap('15px', 'row')}
  align-items: center;
`;

export const CollapsibleContainer = styled.div`
  overflow-y: auto;
  max-height: ${({ maxSize, control }) => (control ? maxSize : '0')}px;
  transition: 0.3s max-height ease-in-out;
  background-color: ${({ theme }) => theme.containerHover};
  min-height: ${({ control }) => (control ? 'auto' : '0')};
`;

export const ExtraInfos = styled.div`
  padding: 24px;
  ${gap('32px', 'column')}
`;

export const ExtraItens = styled.div`
  ${gap('12px', 'column')};
  text-align: start;
  & > h2 {
    margin: 0;
    color: ${({ theme }) => theme.text};
    font-size: 1.5rem;
    font-weight: 600;
  }
  & > p {
    margin: 0;
    color: ${({ theme }) => theme.text};
    font-size: 1rem;
    width: 100%;
    line-height: 1.6;
    padding: 8px 0;
    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: break-word;
    min-height: 20px;
  }

  & > strong {
    color: ${({ theme }) => theme.text};
    font-size: 1rem;
  }
`;

export const IconFlipWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  & svg {
    width: 25px;
    height: 25px;
    fill: ${({ theme }) => theme.primary};
  }
  transition: all 0.2s;
  transform: rotate(-90deg);
  ${({ flip }) => flip && css`
    transform: rotate(0deg);
  `}
`;
export const UsersHeader = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.containerHover};
  & > h2 {
    margin: 0;
    color: ${({ theme }) => theme.text};
    font-size: 1.5rem;
    font-weight: 600;
    width: 100%;
  }
`

export const UsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${gap('8px', 'column')};
  padding: 0 24px;
  & > div {

    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
  }
  & > div:last-child {
    border-bottom: none;
  }`

export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${gap('1rem', 'row')};
  margin-left: 6%;
  align-items: center;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.containerOdd};
  margin-bottom: 8px;
  padding: 12px 16px;
  width: fit-content;
  min-width: 300px;
  &:hover {
    background-color: ${({ theme }) => theme.hover};
  }
`;

export const UserInfoText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  flex: 1;
  & h4 {
    margin: 0;
    word-break: break-word;
  }
  & span {
    font-size: 14px;
    word-break: break-word;
  }
`;
